<template>
    <tr>
        <td class="invoice_id">#{{ multiInvoice.multi_invoice_id }}</td>
        <td class="issued_date">{{ multiInvoice.issued_date }}</td>
        <td class="due_amount">{{ getCurrency }}{{ multiInvoice.balance_due | formatNumber }}</td>
        <td class="deposit">
            <button class="button is-danger" @click="openModal()">Settle Invoices</button>
        </td>
    </tr>
</template>

<script>

    export default {
        props: ['multiInvoice', 'transactionTotals'],
        methods: {
            openModal() {
                this.$store.commit('setMultiInvoicesModal', true)
                this.$store.commit('setCurrentMultiInvoice', {multi_invoice_id: this.multiInvoice.multi_invoice_id, invoices: this.multiInvoice.invoice_ids})
            }
        },
        computed: {
            getCurrency: function () {
                return this.transactionTotals.currency == 2 ? '$' : '¥'
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }
    .picture-td {
        width: 65px;
    }
    .link {
        cursor: pointer;
    }
    .image {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Banking/UnpaidMultiInvoiceTableTr.vue